import { render, staticRenderFns } from "./AdviserSettingsEmailInfo.vue?vue&type=template&id=6135163a&scoped=true&"
import script from "./AdviserSettingsEmailInfo.vue?vue&type=script&lang=js&"
export * from "./AdviserSettingsEmailInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdviserSettingsEmailInfo.vue?vue&type=style&index=0&id=6135163a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135163a",
  null
  
)

export default component.exports